// extracted by mini-css-extract-plugin
module.exports = {"spin":"Spin_spin__2DhWj"};